import { CurrentUser } from '@qualio/ui-components';
import {
  backendTaskApi,
  ExportTaskRequest,
  ExportTaskStatusResponse,
} from '../../../api/backendTask';
import { ExportMethodType } from '../DocumentWorkspace/types';

export const exportViaMedtechTask = async ({
  currentUser,
  request,
  exportTaskMethod,
  onWaitingForDownload,
  onSuccess,
  onFailure,
}: {
  currentUser: CurrentUser;
  request: ExportTaskRequest;
  exportTaskMethod: ExportMethodType;
  onWaitingForDownload: (taskId: string) => void;
  onSuccess: (taskId: string, downloadLink: string) => void;
  onFailure: (taskId: string) => void;
}) => {
  const { task_id: taskId } = await exportTaskMethod(currentUser, request);

  onWaitingForDownload(taskId);

  const result: ExportTaskStatusResponse =
    await backendTaskApi.pollTaskUntilCompletion(currentUser.companyId, taskId);
  if (result.successful) {
    if (result.payload) {
      onSuccess(taskId, result.payload);
    }
  } else {
    onFailure(taskId);
  }
};
